import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentHelperService } from '@shared/services/environment-helper.service';

/** ? */
@Injectable()
export class DiscoveryService {
  private discovery: any
  constructor(private readonly http: HttpClient, private readonly envHelper: EnvironmentHelperService) {}

  public async get(): Promise<any> {
    return this.discovery
      ? Promise.resolve(this.discovery)
      : new Promise((resolve) => {
          this.http
            .get(`${this.envHelper.isLocal ? 'https://apps.inindca.com' : window.location.origin}/services/discovery.properties`, { responseType: 'text' })
            .subscribe((disco) => {
              const props = {};
              for (const i of disco.split('\n')) {
                const [key, val] = i.split('=');
                props[key] = val;
              }
              this.discovery = props
              resolve(this.discovery);
            });
        });
  }
}
